import React from 'react';
import './AdvancedCard.less';

interface AdvancedCardProps {
  children: React.ReactNode;
  testId: string;
}

const AdvancedCard = ({ children, testId }: AdvancedCardProps) => {
  return (
    <div className="advanced-card" data-testid={testId}>
      {children}
    </div>
  );
};

export default AdvancedCard;
